import {DecimalPipe} from '@angular/common';

export type ScoreFormatMode = 'percent' | 'decimal';

type ScoreSlice = { argument: string; value: number };

export const NoData = 'No Data';

const decimalPipe = new DecimalPipe('en-US');

export function hasScoreData(slices: ScoreSlice[], exclude: string[] = []): boolean {
    return slices.some(slice => slice.value > 0 && !exclude.includes(slice.argument));
}

// DevExtreme splits a ring of zero values into equal slices, so No Data is drawn as one grey slice instead.
export function noDataRing(): ScoreSlice[] {
    return [{argument: NoData, value: 1}];
}

// The variable itself, not its computed value, so a drawn ring follows a theme switch.
export const noDataColor = 'var(--bs-secondary-bg)';

export function scoreCenterLabel(hasData: boolean, score: number | null | undefined, formatMode: ScoreFormatMode): string {
    if (!hasData)
        return NoData;

    if (score == null)
        return 'N/A';

    const formatted = decimalPipe.transform(score, '1.0-2') ?? '0';
    return formatMode === 'percent' ? `${formatted}%` : formatted;
}
